import {
  Button,
  fontStyles,
  Icon,
  IconButton,
  TextField,
} from '@monash/portal-react';
import c from './additional-search-optimisation.module.scss';
import { Controller, useFieldArray } from 'react-hook-form';
import classNames from 'classnames';

const EMPTY_TAG_DATA = {
  value: '',
};

const AdditionalSearchOptimisation = ({ disabled }) => {
  const {
    fields: tags,
    append: appendTag,
    remove: removeTag,
  } = useFieldArray({
    name: 'tags',
  });

  return (
    <div className={c.container}>
      <div className={c.section}>
        <div className={classNames(fontStyles.label, c.label)}>Tag</div>
        {tags.map((tag, i) => {
          return (
            <div key={tag.id} className={c.tagInputContainer}>
              <div className={c.grow}>
                <Controller
                  name={`tags.${i}.value`}
                  render={({ field: { value, onChange, onBlur } }) => (
                    <TextField
                      value={value}
                      onChange={onChange}
                      placeholder="Tag name"
                      disabled={disabled}
                    />
                  )}
                />
              </div>
              <IconButton
                icon={Icon.Trash}
                color="var(--card-text-color)"
                aria-label="Delete tag"
                onClick={() => removeTag(i)}
                disabled={disabled}
              />
            </div>
          );
        })}
        <Button
          variant="text"
          size="small"
          className={c.addButton}
          onClick={() => appendTag(EMPTY_TAG_DATA)}
          disabled={disabled}
        >
          Add tag
        </Button>
      </div>
      <div className={c.section}>
        <div className={classNames(fontStyles.label, c.label)}>
          Long description
        </div>
        <Controller
          name="longDescription"
          render={({ field: { value, onChange, onBlur } }) => (
            <TextField
              value={value}
              onChange={onChange}
              multiline
              placeholder="Add long description"
              disabled={disabled}
            />
          )}
        />
      </div>
    </div>
  );
};

export default AdditionalSearchOptimisation;
